import { ErrorHandler, Injectable, inject } from '@angular/core';
import { AppErrorHandler } from '../services/app-error-handler.service';

/**
 * Angular safety-net error handler (Rule 9).
 *
 * Catches any error that escapes all try/catch blocks (missed catches,
 * unhandled promise rejections, Zone.js-tracked async errors) and delegates
 * entirely to AppErrorHandler for structured logging and toast display.
 *
 * If this handler fires in production it indicates a missing try/catch in a
 * store or component — fix the source rather than relying on this safety net.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorHandler = inject(AppErrorHandler);

  handleError(error: unknown): void {
    this.errorHandler.handle(error);
  }
}
